'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getBPJSComponentPersonal(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/employeesalaries_membership`
        const result = await axios.get(url, {
          ...costumHeader('Get BPJS Component Personal', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getBPJSComponentPersonalActive(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/employeesalaries_membership_active`
        const result = await axios.get(url, {
          ...costumHeader('Get BPJS Component Personal Active Only', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getBPJSComponent(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/bpjscompnents`
        const result = await axios.get(url, {
          ...costumHeader('Get BPJS Component', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  saveMembershipBPJS(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/generatememberships`
        const result = await axios.post(url, body, costumHeader('Save Membership (BPJS)', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveBPJSComponent(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/bpjscompnents`
        const result = await axios.post(url, body, costumHeader('Save BPJS Component', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editBPJSComponent(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/bpjscompnents/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit BPJS Component', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
}

export default { actions }